module.exports = "../images/instagram.svg?v=1045ccd";